import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_COMP_FIN_FAILURE, FETCH_COMP_FIN_REQUEST, FETCH_COMP_FIN_SUCCESS } from "../actions/companyFinancialsActions";

  const initialState = {
    financialsData: {},
    loading: true,
    error: null,
  };
  
  const companyFinancialsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COMP_FIN_REQUEST:
        return { ...state, loading: true , payload: action.payload};
      case FETCH_COMP_FIN_SUCCESS:
        return { ...state, loading: false, financialsData: action.payload };
      case FETCH_COMP_FIN_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, loading: false, financialsData: {} };  
      default:
        return state;
    }
  };
  
  export default companyFinancialsReducer;
  